export default __webpack_public_path__ + "static/media/logoMobile.ed0befc9.png";